import { BsCardImage, BsHouse } from "react-icons/bs";
import {
  FaUser,
  FaFileAlt,
  FaCheckCircle,
  FaExclamationTriangle,
  FaFileContract,
} from "react-icons/fa";

import { MdOutlineDocumentScanner } from "react-icons/md";

const iconMap = {
  FaUser: FaUser,
  FaFileContract: FaFileContract,
  FaFileAlt: FaFileAlt,
  FaCheckCircle: FaCheckCircle,
  FaExclamationTriangle: FaExclamationTriangle,
  MdOutlineDocumentScanner: MdOutlineDocumentScanner,
  BsHouse: BsHouse,
  BsCardImage: BsCardImage,
};

export default iconMap;
